module.exports = __webpack_public_path__ + "static/media/google_signin@2x.aa1c7ea2.png";